var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('router-view'),_c('v-cart'),_c('m-buy',{ref:"buybuy"}),(_vm.isLogin && !_vm.$store.state.IsLittleScreen)?_c('m-tools'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }